<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"> </i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              v-if="canUserCreate"
              type="primary"
              class="min-button"
              @click="saveVehicle()"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row justify-content-center">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <div class="imageload2">
                      <div class="">
                        <LazyImage
                          :src="vehicle.information.image || image"
                          imgClasses="img-fluid"
                          beforeClasses=""
                          alt="imgvehicle"
                        />
                      </div>
                    </div>

                    <div class="box-profile-one">
                      <h2
                        class="subtitle capitalize mb-1"
                        v-if="vehicle.parameters.category"
                      >
                        {{ typeCategory(vehicle.parameters.category) }}
                        <br />
                        {{ vehicle.parameters.name }}
                      </h2>

                      <div class="role mb-0 capitalize">
                        {{ vehicle.parameters.type }}
                      </div>
                    </div>

                    <div class="d-inline-block mt-2 mb-3">
                      <div
                        class="badge-profile status-confirmed"
                        v-if="vehicle.owner.active"
                      >
                        <i class="flaticon-check-2 text-success f25 mr-2"></i>
                        <span>Active</span>
                      </div>

                      <div class="badge-profile status-cancelled " v-else>
                        <i class="flaticon-check-2 text-danger f25 mr-2"></i>
                        <span>Inactive</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card ">
                <h2 for="driver_ProfileImage" class="subtitle">
                  Tags
                  <el-popover
                    placement="top"
                    trigger="hover"
                    width="300"
                    class="curp"
                  >
                    <span class="mb-2 d-block">
                      Tags describe the vehicle's features and special services,
                      such as accessibility options, vehicle type, or included
                      amenities.
                    </span>
                    <div class="badge badge-primary" slot="reference">
                      ?
                    </div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div class="col-12">
                    <div class="mb-4 ">
                      <el-select
                        multiple
                        filterable
                        v-model="selectedTagIds"
                        @change="setVehicleTags"
                        id="tags"
                        name="tags"
                        class="input-custom mb-4"
                      >
                        <el-option
                          v-for="option in tagsOptions"
                          :value="option._id"
                          :label="option.name"
                          :key="option._id"
                        >
                          <div class="row">
                            <div class="col-lg-8 col-md-8 col-sm-8 col-8">
                              <span class="hide-data">
                                {{ option.name }}
                              </span>
                            </div>
                          </div>
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-12 col-md-12">
          <tabs
            tabNavClasses="tabs-home justify-content-around tab-profiles"
            :value="tabActive"
            @changeTabActive="changeTabActive"
          >
            <tab-pane id="Overview" title="Overview" ref="Overview">
              <div class="card">
                <h2 class="subtitle mb-3">Parameters</h2>

                <div class="row">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <WSelect
                      v-bind:class="{
                        'is-invalid': $v.vehicle.parameters.branch.$error
                      }"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="remoteMethodBranch"
                      :loading="loading"
                      placeholder="Destination / Supplier"
                      v-model="vehicle.parameters.branch"
                      label="Destination / Supplier"
                      markrequired
                      :error="
                        $v.vehicle.parameters.branch.$error
                          ? `Select a Destination`
                          : ''
                      "
                    >
                      <el-option
                        v-for="(branch, index) in branches"
                        :value="branch._id"
                        :label="
                          `${branch.name} - ${branch.supplier.businessDetails.name}`
                        "
                        :key="index"
                      >
                        <span class="hide-data-inline coin-left">{{
                          branch.name
                        }}</span>
                        <span class="hide-data-inline coin-right">{{
                          branch.supplier.businessDetails.name
                        }}</span>
                      </el-option>
                    </WSelect>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-4"
                    v-bind:class="{
                      'is-invalid': $v.vehicle.parameters.category.$error
                    }"
                  >
                    <label class="title-label"
                      ><span class="markrequired">*</span>Category</label
                    >

                    <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                      <b-form-radio-group
                        :aria-describedby="ariaDescribedby"
                        id="btn-radios-1"
                        v-model="vehicle.parameters.category"
                        :options="categories"
                        name="radios-btn-default"
                        buttons
                        value-field="value"
                        text-field="label"
                        size="md"
                        button-variant="outline-neutral"
                        class="buttons-type "
                      ></b-form-radio-group>
                    </b-form-group>
                    <small
                      class="invalid-feedback"
                      v-if="$v.vehicle.parameters.category.$error"
                      >Select a Category</small
                    >
                  </div>

                  <div class="col-xl-4 col-lg-3 col-md-3 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'is-invalid': $v.vehicle.parameters.type.$error
                      }"
                      placeholder="Type"
                      v-model="vehicle.parameters.type"
                      filterable
                      label="Vehicle Type"
                      @change="selectVehicleType"
                      markrequired
                      :error="
                        $v.vehicle.parameters.type.$error
                          ? `Select a vehicle Type`
                          : ''
                      "
                    >
                      <el-option
                        v-for="typev in vehicleTypes"
                        :value="typev.value"
                        :label="typev.label"
                        :key="typev.label"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'is-invalid': $v.vehicle.parameters.make.$error
                      }"
                      placeholder="Make"
                      v-model="vehicle.parameters.make"
                      @change="selectVehicleMake"
                      filterable
                      label="Make"
                      markrequired
                      :error="
                        $v.vehicle.parameters.make.$error ? `Select a Make` : ''
                      "
                    >
                      <el-option
                        v-for="options in makes"
                        :value="options.value"
                        :label="options.label"
                        :key="options.label"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'is-invalid': $v.vehicle.parameters.model.$error
                      }"
                      placeholder="Model"
                      v-model="vehicle.parameters.model"
                      @change="selectVehicleModel"
                      filterable
                      label="Model"
                      markrequired
                      :error="
                        $v.vehicle.parameters.model.$error
                          ? `Select a Model`
                          : ''
                      "
                    >
                      <el-option
                        v-for="(options, index) in models"
                        :value="options.value"
                        :label="options.label"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                    <base-input
                      label="Name"
                      id="vehicle_name"
                      name="vehicle_name"
                      v-model="vehicle.parameters.name"
                      placeholder="Name"
                      disabled
                    />
                  </div>

                  <div class="col-xl-3 col-lg-2 col-md-2 col-sm-4 col-6">
                    <base-input
                      label="Nº Seats"
                      id="vehicle_Seats"
                      name="vehicle_Seats"
                      v-model="$v.vehicle.parameters.n_seats.$model"
                      mode="integer"
                      @input="selectNumberSeats"
                      placeholder="Seats"
                      markrequired
                      :tooltip="true"
                      titleTooltip="<strong>Validation Seats</strong>"
                      contentTooltip="The seating capacity is determined based on the available space for passengers, varying according to the type of vehicle. It is calculated by averaging the total number of seats in the vehicle, excluding the driver and co-pilot seats."
                      :error="
                        !$v.vehicle.parameters.n_seats.numeric ||
                        $v.vehicle.parameters.n_seats.$error
                          ? getCustomErrorMessage($v.vehicle.parameters.n_seats)
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-3 col-lg-2 col-md-2 col-sm-4 col-6">
                    <BaseNumberInput
                      label="Nº Bags"
                      v-model="vehicle.parameters.n_suitcases"
                      mode="integer"
                      id="vehicle_suitcases"
                      name="vehicle_suitcases"
                      placeholder="Suit"
                      markrequired
                      :error="
                        !$v.vehicle.parameters.n_suitcases.numeric ||
                        $v.vehicle.parameters.n_suitcases.$error
                          ? `Enter a N° Bags`
                          : ''
                      "
                    />
                  </div>
                  <div class="col-xl-3 col-lg-2 col-md-2 col-sm-4 col-6 mb-4">
                    <label class="title-label">Active</label>
                    <base-switch
                      class="sw-md mt-2 ml-2"
                      v-model="vehicle.owner.active"
                    ></base-switch>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle mb-3">Information</h2>
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <base-input
                      label="Licence Plate"
                      v-model="vehicle.information.licence"
                      id="vehicle_licencePlate"
                      name="vehicle_licencePlate"
                      placeholder="Licence Plate"
                      markrequired
                      :error="
                        !$v.vehicle.information.licence.minLength ||
                        $v.vehicle.information.licence.$error ||
                        licensePlateDuplication
                          ? licensePlateMessage
                          : ''
                      "
                      :successMessage="licensePlateMessage"
                      :valid="!licensePlateDuplication"
                      @input="licensePlateDuplicationCheck"
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <WSelect
                      placeholder="Year"
                      v-model="vehicle.information.year"
                      label="Year"
                      filterable
                    >
                      <el-option
                        v-for="year in years"
                        :value="year.value"
                        :label="year.label"
                        :key="year.label"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <WSelect
                      class="input-ap select-color"
                      placeholder="Color"
                      v-model="vehicle.information.color"
                      style
                      filterable
                      prepend-icon="flaticon-bold-dry-clean"
                      label="Color"
                    >
                      <template slot="prefix">
                        <i
                          class="flaticon-bold-dry-clean"
                          v-bind:style="{ color: vehicle.information.color }"
                        ></i>
                      </template>

                      <el-option
                        v-for="color in colors"
                        :value="color.value"
                        :label="color.label"
                        :key="color.label"
                      >
                        <span class="capitalize">
                          <i
                            class="flaticon-bold-dry-clean mr-2"
                            v-bind:style="{ color: color.color }"
                          ></i>
                          {{ color.value }}
                        </span>
                      </el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <base-input
                      label="Vehicle ID/VIN"
                      v-model="vehicle.information.vin"
                      id="vehicle_ID"
                      name="vehicle_ID"
                      placeholder="Vehicle ID/VIN"
                      :error="
                        !$v.vehicle.information.vin.minLength ||
                        $v.vehicle.information.vin.$error
                          ? `Minimum ${$v.vehicle.information.vin.$params.minLength.min} letters.`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <base-input
                      label="Registration Expired"
                      :error="
                        $v.vehicle.information.regis_expired.$error
                          ? `The selected date must be greater than the current one`
                          : ''
                      "
                      addon-left-icon="flaticon-calendar"
                      v-bind:class="{
                        'invalid-feedback-flatpicker':
                          $v.vehicle.information.regis_expired.$error
                      }"
                    >
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{
                          altFormat: formatDateFlatPicker,
                          altInput: true,
                          dateFormat: 'Y-m-d',
                          allowInput: true
                        }"
                        class="input-custom"
                        v-model="$v.vehicle.information.regis_expired.$model"
                        id="vehicle_registration"
                        name="vehicle_registration"
                        placeholder="Date Expired"
                      ></flat-picker>
                    </base-input>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle mb-3">Specifications</h2>
                <div class="row">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <WSelect
                      placeholder="Drivetrain"
                      v-model="vehicle.especifications.driver_train"
                      label="Drivetrain"
                      filterable
                    >
                      <el-option
                        v-for="options in driveTrain"
                        :value="options.value"
                        :label="options.label"
                        :key="options.label"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <WSelect
                      placeholder="Fuel Type"
                      v-model="vehicle.especifications.fuel_type"
                      label="Fuel Type"
                      filterable
                    >
                      <el-option
                        v-for="options in fuelType"
                        :value="options.value"
                        :label="options.label"
                        :key="options.label"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <base-input
                      label="Fuel Economy"
                      v-model="vehicle.especifications.fuel_economy"
                      id="vehicle_fueleconomy"
                      name="vehicle_fueleconomy"
                      placeholder="Fuel Economy"
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-4">
                    <label class="title-label">Fuel Economy Unit</label>
                    <div class="option-transfers">
                      <b-form-radio-group
                        id="btn-radios-1"
                        v-model="vehicle.especifications.fuel_economy_unit"
                        :options="fuelUnity"
                        name="radios-btn-default"
                        buttons
                        value-field="value"
                        text-field="label"
                        button-variant="group-neutral"
                        class="buttons-type"
                      ></b-form-radio-group>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-5 col-6 mb-4">
                    <label class="title-label">Car State</label>
                    <div class="option-transfers">
                      <b-form-radio-group
                        id="btn-radios-2"
                        v-model="vehicle.especifications.car_state"
                        :options="carState"
                        name="radios-btn-default"
                        buttons
                        value-field="value"
                        text-field="label"
                        button-variant="group-neutral"
                        class="buttons-type"
                      ></b-form-radio-group>
                    </div>
                  </div>

                  <div class="col-xl-8 col-lg-7 col-md-7 col-sm-8 col-12">
                    <WSelect
                      placeholder="Driver"
                      v-model="vehicle.especifications.assigned_drive"
                      label="Assigned Driver"
                      filterable
                      v-if="false"
                    >
                      <el-option
                        v-for="(option, index) in drivers"
                        :value="option._id"
                        :label="`${option.first_name} ${option.last_name}`"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle mb-3">Insurance Information</h2>
                    <div class="row">
                      <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 ">
                        <div class="row">
                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                          >
                            <base-input
                              v-model.trim="vehicle.insurance.company"
                              id="vehicle_insuranceCompany"
                              name="vehicle_insuranceCompany"
                              label="Insurance Company"
                              placeholder="Insurance"
                            />
                          </div>

                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                          >
                            <base-input
                              v-model.trim="vehicle.insurance.policy_number"
                              id="vehicle_policyNumber"
                              name="vehicle_policyNumber"
                              label="Policy Number"
                              placeholder="Policy Number"
                            />
                          </div>

                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2"
                          >
                            <base-input
                              label="Renewal Date"
                              :error="
                                $v.vehicle.insurance.expiration_date.$error
                                  ? `The selected date must be greater than the current one`
                                  : ''
                              "
                              addon-left-icon="ni ni-calendar-grid-58"
                              v-bind:class="{
                                'invalid-feedback-flatpicker':
                                  $v.vehicle.insurance.expiration_date.$error
                              }"
                            >
                              <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                :config="{
                                  altFormat: formatDateFlatPicker,
                                  altInput: true,
                                  dateFormat: 'Y-m-d',
                                  allowInput: true
                                }"
                                class="input-custom"
                                v-model="
                                  $v.vehicle.insurance.expiration_date.$model
                                "
                                id="vehicle_InsuranceRegistration"
                                name="vehicle_InsuranceRegistration"
                                placeholder="Date Expired"
                              ></flat-picker>
                            </base-input>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 text-center"
                      >
                        <label for="insuranceCard" class="title-label-np">
                          Insurance Card
                          <el-popover
                            placement="top"
                            trigger="hover"
                            width="300"
                            class="curp"
                          >
                            <ul class="ul-pop">
                              <li>Allowed Dimensions: 500 x 500 px</li>
                              <li>Maximum Size: 2MB</li>
                              <li>Allowed Formats: GIF,JPG,JPEG,PNG</li>
                            </ul>
                            <div class="badge badge-primary" slot="reference">
                              <span>?</span>
                            </div>
                          </el-popover>
                        </label>
                        <div>
                          <div class="imageload2">
                            <div class="image">
                              <div
                                v-if="vehicle.insurance.insurance_card !== ''"
                                v-bind:style="{
                                  backgroundImage:
                                    'url(' +
                                    vehicle.insurance.insurance_card +
                                    ')'
                                }"
                                class="imgLogoIcon"
                              ></div>
                              <div
                                v-else
                                v-bind:style="{
                                  backgroundImage: 'url(' + imageDefault + ')'
                                }"
                                class="imgLogoIcon"
                              ></div>
                            </div>
                            <div class="contentfile2">
                              <base-dropdown menuOnRight>
                                <base-button
                                  slot="title-container"
                                  type="primary"
                                  class="dropdown-toggle btn-icon-only buttonfiles2"
                                >
                                  <i class="flaticon-camera m-0"></i>
                                </base-button>
                                <span class="dropdown-item">
                                  <base-input
                                    class="filebutton2"
                                    type="file"
                                    name="imagepreview2"
                                    id="imagepreview2"
                                    accesskey="insurance"
                                    enctype="multipart/form-data"
                                    accept="image/jpeg, image/jpg, image/png"
                                    @change="uploadFile"
                                  ></base-input
                                  >Change Image
                                </span>

                                <span
                                  class="dropdown-item"
                                  v-if="
                                    selfile ||
                                      vehicle.insurance.insurance_card !== ''
                                  "
                                  @click="
                                    downloadPicture(
                                      vehicle.insurance.insurance_card
                                    )
                                  "
                                  >Download</span
                                >
                                <span
                                  class="dropdown-item"
                                  v-if="
                                    selfile ||
                                      vehicle.insurance.insurance_card !== ''
                                  "
                                  @click="clearfile('insurance')"
                                  >Remove</span
                                >
                              </base-dropdown>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle mb-3">Scheduled Maintenance</h2>
                    <div class="row">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                      >
                        <base-input
                          label="From"
                          :error="
                            $v.vehicle.scheduled.from.$error
                              ? `The selected date must be greater than the current one`
                              : ''
                          "
                          addon-left-icon="ni ni-calendar-grid-58"
                          v-bind:class="{
                            'invalid-feedback-flatpicker':
                              $v.vehicle.scheduled.from.$error
                          }"
                        >
                          <flat-picker
                            slot-scope="{ focus, blur }"
                            @on-open="focus"
                            @on-close="blur"
                            :config="{
                              altFormat: formatDateFlatPicker,
                              altInput: true,
                              dateFormat: 'Y-m-d',
                              allowInput: true
                            }"
                            class="input-custom"
                            v-model="$v.vehicle.scheduled.from.$model"
                            id="vehicle_scheduleFrom"
                            name="vehicle_scheduleFrom"
                            placeholder="Date Expired"
                          ></flat-picker>
                        </base-input>
                      </div>

                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                      >
                        <base-input
                          label="To"
                          :error="
                            $v.vehicle.scheduled.to.$error
                              ? `The selected date must be greater than the scheduled from`
                              : ''
                          "
                          addon-left-icon="ni ni-calendar-grid-58"
                          v-bind:class="{
                            'invalid-feedback-flatpicker':
                              $v.vehicle.scheduled.to.$error
                          }"
                        >
                          <flat-picker
                            slot-scope="{ focus, blur }"
                            @on-open="focus"
                            @on-close="blur"
                            :config="{
                              altFormat: formatDateFlatPicker,
                              altInput: true,
                              dateFormat: 'Y-m-d',
                              allowInput: true
                            }"
                            class="input-custom"
                            v-model="$v.vehicle.scheduled.to.$model"
                            id="vehicle_scheduleTo"
                            name="vehicle_scheduleTo"
                            placeholder="Date Expired"
                          ></flat-picker>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane
              id="OwnerInformation"
              title="Owner Information"
              ref="OwnerInformation"
            >
              <div class="card">
                <h2 class="subtitle mb-3">Owner Information</h2>
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="vehicle.owner.company_name"
                      id="vehicle_companyName"
                      name="vehicle_companyName"
                      label="Company Name"
                      placeholder="Company Name"
                    />
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="vehicle.owner.contact_name"
                      id="vehicle_contactName"
                      name="vehicle_contactName"
                      label="Contact Name"
                      placeholder="Contact Name"
                    />
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-7 col-sm-6 col-12">
                    <base-input
                      v-model.trim="vehicle.owner.address"
                      id="vehicle_address"
                      name="vehicle_address"
                      label="Street address, apartment, suite, etc."
                      placeholder="Street address, apartment, suite, etc"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <base-input
                      v-model.trim="vehicle.owner.city"
                      id="vehicle_city"
                      name="vehicle_city"
                      label="City"
                      placeholder="City"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <base-input
                      v-model.trim="vehicle.owner.state"
                      id="vehicle_state"
                      name="vehicle_state"
                      label="State/Province/Region"
                      placeholder="State/Province/Region"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <base-input
                      v-model.trim="vehicle.owner.zip_code"
                      id="vehicle_zipCode"
                      name="vehicle_zipCode"
                      label="Zip/Postal Code"
                      placeholder="Zip/Postal Code"
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <WSelect
                      id="vehicle_country"
                      name="vehicle_country"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="remoteMethod"
                      :loading="loading"
                      placeholder="Enter a Country"
                      v-model="vehicle.owner.conuntry"
                      label="Country"
                    >
                      <el-option
                        v-for="country in options"
                        :value="country.name"
                        :label="country.name"
                        :key="country.name"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { VehiclesAPI, DriversAPI, TagsAPI } from "../../../core/api";
import { TAG_TYPES } from "../../../core/constants";
import { buildTagsFromSelection } from "../../../core/services/tags.service";
import flatPicker from "vue-flatpickr-component";
import moment from "moment-timezone";
import lodash from "lodash";
import "flatpickr/dist/flatpickr.css";
import { Switch, Card, DatePicker } from "element-ui";
import Swal from "sweetalert2";
import {
  required,
  minLength,
  numeric,
  minValue
} from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import { IMAGE_BASE_URL } from "../../../core/config/env";
import { FileService } from "../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewVehicles",
  data() {
    return {
      vehicle: {
        parameters: {
          branch: "",
          type: "",
          make: "",
          model: "",
          category: "",
          name: "",
          n_seats: 0,
          n_suitcases: 0,
          type_category: "",
          isComposite: false,
          composition: "",
          tags: []
        },
        information: {
          licence: "",
          year: "",
          vin: "",
          color: "black",
          regis_expired: "",
          image: ""
        },
        especifications: {
          driver_train: "",
          fuel_type: "",
          fuel_economy: "",
          fuel_economy_unit: "",
          assigned_drive: "",
          car_state: ""
        },
        owner: {
          company_name: "",
          contact_name: "",
          conuntry: "",
          state: "",
          city: "",
          address: "",
          zip_code: "",
          active: true
        },
        scheduled: {
          from: "",
          to: ""
        },
        insurance: {
          company: "",
          policy_number: "",
          expiration_date: "",
          expiration_time: "",
          insurance_card: ""
        },
        timezone: "",
        relationship: {
          owner: null,
          type: "admin"
        }
      },
      categories: [
        { label: "Business", value: "business" },
        { label: "Luxury", value: "luxury" },
        { label: "Standard", value: "standard" }
      ],
      vehicleTypes: [
        { label: "Sedan", value: "sedan" },
        { label: "Boats", value: "boat" },
        { label: "Coach", value: "coach" },
        { label: "Limousine", value: "limousine" },
        { label: "Minibus", value: "minibus" },
        { label: "MidiCoach", value: "midicoach" },
        { label: "Minivan", value: "minivan" },
        { label: "MPV", value: "mpv" },
        { label: "Pickup", value: "pickup" },
        { label: "Premium Sedans", value: "premium_sedans" },
        { label: "SUVs", value: "suvs" }
      ],
      makes: [],
      models: [],
      years: [],
      colors: [
        { label: "Black", color: "#000000", value: "black" },
        { label: "Blue", color: "#000a98", value: "blue" },
        { label: "Brown", color: "#99322b", value: "brown" },
        { label: "Gray", color: "#D2D2D2", value: "gray" },
        { label: "Red", color: "#ec0000", value: "red" },
        { label: "White", color: "#ffffff", value: "white" },
        { label: "Pink", color: "#f81894", value: "pink" }
      ],
      drivers: [],
      driveTrain: [
        { label: "Front-Wheel drive", value: "front-wheel-drive" },
        { label: "Rear-Wheel drive", value: "rear-wheel-drive" },
        { label: "All-Wheel drive", value: "all-wear" },
        { label: "Four-Wheel drive", value: "four-wheel-drive" }
        // { label: "Electric", value: "electric" },
      ],
      fuelType: [
        { label: "CNC", value: "cnc" },
        { label: "Diesel", value: "diesel" },
        { label: "Electric", value: "electric" },
        { label: "Gasoline", value: "gasoline" },
        { label: "GNC", value: "gnc" },
        { label: "Hybrid", value: "hybrid" },
        { label: "LPG", value: "lpg" }
        // { label: "XXX ", value: "xxx" },
      ],
      fuelUnity: [
        { label: "mpg", value: "mpg" },
        { label: "km/l", value: "km/l" }
        // { label: "mpg-e", value: " mpg-e" },
      ],
      carState: [
        { label: "Affiliate", value: "affiliate" },
        { label: "Owned", value: "owned" }
      ],
      selfile: false,
      imagePreview: "",
      options: [],
      branches: [],
      loading: false,
      image: require("rhomtrip_assets/src/img/no-preview-car.jpg"),
      imageDefault: `${IMAGE_BASE_URL}/vehicles/no-preview.png`,
      model: null,
      vehicleCopy: {},
      leftyVehicle: false,
      branchId: null,
      licensePlateDuplication: false,
      licensePlateMessage: "",
      seatsMessage: "",
      carsOptions: [],
      tabActive: "Overview",
      selectedTagIds: [],
      tagsOptions: []
    };
  },
  watch: {
    "vehicle.parameters.branch": {
      handler: async function(current, old) {
        let branch = this.branches.find(element => element._id === current);
        if (branch) {
          this.branchId = current;
          if (this.vehicle.information.licence) {
            this.licensePlateDuplication = false;
            this.licensePlateMessage = "";
            await this.licensePlateDuplicationCheck(
              this.vehicle.information.licence
            );
          }
          this.vehicle.timezone = branch.timezone;
          await this.getDriversByBranchId(current);
        }
      },
      deep: true
    }
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Vehicles",
        to: "/vehicles"
      },

      {
        text: "New Vehicle",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.years = this.getYears(1990);
    this.getGlobalCountries();
    this.getBranchesOptions();
    this.vehicleTypes.sort(this.sortAscending);
    this.vehicleCopy = lodash.cloneDeep(this.vehicle);
    this.carsOptions = await this.getCarsOptions();
    this.tagsOptions = await this.getVehicleTagsOptions();
  },
  methods: {
    sortAscending: function(a, b) {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    },
    uploadFile: async function(event) {
      let [file] = event.target.files;
      let toPreview = event.target.accessKey;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB nor exceed 500x500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile(toPreview);
      } else {
        let fileData = FileService.generateResourceData(
          "/vehicles/insurances",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.imagePreview = URL.createObjectURL(file);
          this.vehicle.insurance.insurance_card = urlFile;
          this.selfile = true;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB nor exceed 500x500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile: function(file) {
      this.imagePreview;
      this.vehicle.insurance.insurance_card = "";
      this.selfile = false;
    },
    async saveVehicle(router = null) {
      let vehicle = lodash.cloneDeep(this.vehicle);
      if (!this.$v.vehicle.$invalid && !this.licensePlateDuplication) {
        vehicle.relationship.owner = this.getOwner(this.sesion);
        await this.createVehicle(vehicle, router);
      } else {
        this.$v.vehicle.$touch();
        await this.licensePlateDuplicationCheck(vehicle.information.licence);
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createVehicle(vehicle, router) {
      try {
        this.setLoad(true);
        let { data } = await VehiclesAPI.createVehicle(
          vehicle,
          this.sesion.token
        );
        this.setLoad(false);
        this.leftyVehicle = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Services has been Saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(router ? router : "/vehicles");
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.leftyVehicle = true;
        if (error.response.status === 400) {
          let errors = error.response.data.error || [];
          this.handleBadRequest(errors);
        } else {
          this.handleError(
            error,
            "The Operation could not be completed. Please try again"
          );
        }
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethodBranch(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.branches = this.branchesOptions.filter(branch => {
            return branch.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    getYears(start) {
      let end = moment().year();
      let years = [];
      for (let index = end; index >= start; index--) {
        years.push({ label: `${index}`, value: `${index}` });
      }
      return years;
    },
    validateTypeVehicle(numberSeats, type) {
      if (type === "sedan") {
        this.seatsMessage = "Enter 1 to 3 seats";
        return numberSeats >= 1 && numberSeats <= 3;
      } else if (type === "boat") {
        this.seatsMessage = "Enter 1 to 10 seats";
        return numberSeats >= 1 && numberSeats <= 10;
      } else if (type === "coach") {
        this.seatsMessage = "Enter 27 to 85 seats";
        return numberSeats >= 27 && numberSeats <= 85;
      } else if (type === "limousine") {
        this.seatsMessage = "Enter 1 to 14 seats";
        return numberSeats >= 1 && numberSeats <= 14;
      } else if (type === "minibus") {
        this.seatsMessage = "Enter 8 to 22 seats";
        return numberSeats >= 8 && numberSeats <= 22;
      } else if (type === "midicoach") {
        this.seatsMessage = "Enter 14 to 35 seats";
        return numberSeats >= 14 && numberSeats <= 35;
      } else if (type === "minivan") {
        this.seatsMessage = "Enter 1 to 9 seats";
        return numberSeats >= 1 && numberSeats <= 9;
      } else if (type === "mpv") {
        this.seatsMessage = "Enter 1 to 7 seats";
        return numberSeats >= 1 && numberSeats <= 7;
      } else if (type === "pickup") {
        this.seatsMessage = "Enter 1 to 4 seats";
        return numberSeats >= 1 && numberSeats <= 4;
      } else if (type === "premium_sedans") {
        this.seatsMessage = "Enter 1 to 3 seats";
        return numberSeats >= 1 && numberSeats <= 3;
      } else if (type === "suvs") {
        this.seatsMessage = "Enter 1 to 6 seats";
        return numberSeats >= 1 && numberSeats <= 6;
      }
    },

    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    handleBadRequest(errors) {
      for (let index = 0; index < errors.length; index++) {
        const error = errors[index];
        if (error.code === 11000) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please the license plate must be unique",
            icon: "flaticon-warning-1"
          });
          break;
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
          break;
        }
      }
    },
    async getDriversByBranchId(branchId) {
      try {
        let { data } = await DriversAPI.getDriversByBranches(
          branchId,
          this.sesion.token
        );
        if (data.status) {
          this.drivers = data.data;
        } else {
          this.drivers = [];
        }
      } catch (error) {
        this.drivers = [];
      }
    },
    selectNumberSeats(numberSeats) {
      if (numberSeats >= 1 && numberSeats <= 3) {
        this.vehicle.parameters.type_category = "car";
      } else if (numberSeats > 3 && numberSeats <= 9) {
        this.vehicle.parameters.type_category = "van";
      } else if (numberSeats > 9 && numberSeats <= 19) {
        this.vehicle.parameters.type_category = "minibus";
      } else if (numberSeats > 19 && numberSeats <= 35) {
        this.vehicle.parameters.type_category = "coach";
      } else if (numberSeats > 35 && numberSeats <= 85) {
        this.vehicle.parameters.type_category = "big-bus";
      }
    },
    selectVehicleType(type) {
      this.vehicle.parameters.make = "";
      this.vehicle.parameters.name = "";
      this.vehicle.parameters.model = "";
      this.vehicle.parameters.n_seats = "0";
      this.image = this.vehicle.information.image = require("rhomtrip_assets/src/img/no-preview-car.jpg");
      let types = this.carsOptions.filter(element => element.type === type);

      this.makes = this.getMakes(types);
    },
    selectVehicleMake(make) {
      if (make) {
        this.vehicle.parameters.name = "";
        this.vehicle.parameters.model = "";
        this.models = this.getModels(make);
      } else {
        this.vehicle.parameters.model = "";
        this.models = [];
      }
    },
    selectVehicleModel(vehicleModel) {
      let model = this.models.find(element => element.value === vehicleModel);
      if (model) {
        this.model = model;
        this.vehicle.parameters.isComposite = model.isComposite;
        this.vehicle.parameters.composition = model.composition;
        this.vehicle.parameters.name = this.model.name;
        this.image = `${IMAGE_BASE_URL}/vehicles/${model.ref}.png`;
        this.vehicle.information.image = this.image;
      }
    },
    getMakes(types) {
      return types
        .filter((value, index, self) => {
          return self.map(e => e.make).indexOf(value.make) === index;
        })
        .map(element => {
          return {
            label: element.make_label,
            value: element.make,
            type: element.type
          };
        })
        .sort(this.sortAscending);
    },
    getModels(make) {
      return this.carsOptions
        .filter((element, index, self) => {
          return (
            element.make === make &&
            element.type === this.vehicle.parameters.type
          );
        })
        .map(element => {
          return {
            label: element.model_label,
            value: element.model,
            type: element.type,
            make: element.make,
            ref: element.slug,
            name: element.label,
            isComposite: element.isComposite,
            composition: element.composition
          };
        })
        .sort(this.sortAscending);
    },
    getOwner(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    goToPreviousPage() {
      goBack(this);
    },
    async licensePlateDuplicationCheck(licensePlate) {
      try {
        if (licensePlate && this.branchId) {
          let { data } = await VehiclesAPI.licensePlateDuplicationCheck(
            this.branchId,
            licensePlate,
            this.sesion.token
          );
          if (data.status) {
            this.licensePlateDuplication = data.data.isDuplicate;
            this.licensePlateMessage = data.data.isDuplicate
              ? "Duplicate for this Destination"
              : "";
          } else {
            this.licensePlateDuplication = true;
            this.licensePlateMessage = "Duplicate for this Destination";
          }
        } else {
          this.licensePlateDuplication = true;
          this.licensePlateMessage =
            licensePlate === "" ? "Enter license plate." : "";
        }
      } catch (error) {
        this.licensePlateDuplication = true;
        this.licensePlateMessage =
          licensePlate === "" ? "Enter license plate." : "";
      }
    },
    mustBeAfterNow(date) {
      let today = moment().utc(true);
      return moment(date).isSameOrAfter(today, "day");
    },
    mustBeAfterDate(startDate, endDate) {
      return moment(endDate).diff(startDate, "days") >= 1;
    },
    getCustomErrorMessage(numberSeats) {
      if (!numberSeats.required) {
        return "Enter a N° Seats";
      } else if (!numberSeats.numeric) {
        return "Enter a number";
      } else if (numberSeats.$model <= 0) {
        return "Enter a N° of Seats";
      } else if (!numberSeats.customValidator) {
        return this.seatsMessage;
      } else {
        return 0;
      }
    },
    isInVehicleModule(modules = []) {
      if (!(modules.indexOf("vehicles") > -1)) {
        this.setVehicleSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.vehicle, this.vehicleCopy);
      if (!isEqual && !this.leftyVehicle && this.canUserCreate) {
        Swal.fire({
          title: "Important",
          html:
            "The Vehicle has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        }).then(result => {
          if (result.value) {
            this.saveVehicle(to.path);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            next();
          }
        });
      } else {
        next();
      }
    },
    async getCarsOptions() {
      try {
        let { data } = await VehiclesAPI.getCarsOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    /**
     * Get the vehicle tags catalog of the requester for the tags select.
     * @returns {Promise<Object[]>} The vehicle tags, or an empty list on error.
     */
    async getVehicleTagsOptions() {
      try {
        let { data } = await TagsAPI.getTagsOptionsByType(
          TAG_TYPES.VEHICLE,
          this.sesion.token
        );
        return data || [];
      } catch (error) {
        return [];
      }
    },
    /**
     * Set the vehicle tags from the tag ids selected in the tags select.
     * @param {string[]} selectedTagIds - The selected tag ids.
     */
    setVehicleTags(selectedTagIds = []) {
      this.vehicle.parameters.tags = buildTagsFromSelection(
        selectedTagIds,
        this.tagsOptions
      );
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    typeCategory: function(type) {
      if (type === "business") {
        return "Business Class";
      } else if (type === "luxury") {
        return "Luxury Class";
      } else {
        return "Standard Class";
      }
    },
    ...mapActions(["getGlobalCountries", "getBranchesOptions"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setVehicleSearchCriteria"
    ])
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    flatPicker,
    WSelect
  },
  computed: {
    ...mapGetters([
      "countries",
      "branchesOptions",
      "sesion",
      "userRole",
      "sigout"
    ]),
    canUserCreate() {
      return isUserAuthorized("VEHICLES", this.userRole, "CREATE");
    },
    formatDateFlatPicker: function() {
      return "d-M-Y";
    },
    formatTimeFlatPicker: function() {
      return {
        altFormat: "G:i K",
        dateFormat: "G:i K",
        time_24hr: false
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInVehicleModule(to.meta.modules);
    this.detectChanges(to, from, next);
  },
  validations: {
    vehicle: {
      parameters: {
        branch: {
          required
        },
        type: {
          required
        },
        make: {
          required
        },
        model: {
          required
        },
        category: {
          required
        },
        name: {
          required,
          minLength: minLength(3)
        },
        n_seats: {
          required,
          numeric,
          minValue: minValue(1),
          customValidator: function(value) {
            if (this.vehicle.parameters.type) {
              return value > 0
                ? this.validateTypeVehicle(value, this.vehicle.parameters.type)
                : false;
            } else {
              return false;
            }
          }
        },
        n_suitcases: {
          required,
          numeric,
          minValue: minValue(1)
        },
        type_category: {
          required
        }
      },
      information: {
        licence: {
          required,
          minLength: minLength(3)
        },
        regis_expired: {
          customValidator: function(value) {
            return value ? this.mustBeAfterNow(value) : true;
          }
        },
        vin: {
          minLength: minLength(17)
        }
      },
      scheduled: {
        from: {
          customValidator: function(value) {
            return value ? this.mustBeAfterNow(value) : true;
          }
        },
        to: {
          customValidator: function(value) {
            return value && this.vehicle.scheduled.from
              ? this.mustBeAfterDate(this.vehicle.scheduled.from, value)
              : true;
          }
        }
      },
      insurance: {
        expiration_date: {
          customValidator: function(value) {
            return value ? this.mustBeAfterNow(value) : true;
          }
        }
      }
    }
  }
};
</script>
